import type { TableCellProps } from '@chakra-ui/react'
import { Image, Table, Tbody, Td, Text, Tr } from '@chakra-ui/react'
import { formatPrice } from 'BrokerTsLib/src/Utils/formatPrice'

import { Insurer } from 'BrokerTsLib/src/enums'
import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../components/FormSection'
import { getLogo } from '../../utils/companiesLogos'
import { formatDate } from '../../utils/formatDate'
import { CancelContract } from '../CancelContract'

interface RecapTableRowProps extends TableCellProps {
  col1: string | React.ReactNode
  col2?: string | React.ReactNode
  col3?: string | React.ReactNode
  isHighlighted?: boolean
}

export const RecapTableRow = ({ col1, col2, col3, isHighlighted, sx, ...rest }: RecapTableRowProps) => {
  return (
    <Tr sx={{ m: 0, p: 0 }}>
      <Td sx={{ w: '15rem', p: 1, ...sx }}>
        {col1 && <Text sx={{ fontWeight: isHighlighted ? 'semibold' : 'medium' }}>{col1}</Text>}
      </Td>
      <Td sx={{ p: 1, ...sx }}>{col2 && col2}</Td>
      {col3 && (
        <Td sx={{ p: 1, fontWeight: isHighlighted ? 'semibold' : 'normal', textAlign: 'end', ...sx }}>
          {col3}
        </Td>
      )}
    </Tr>
  )
}

export const Recap = () => {
  return (
    <FormSection>
      <FormSectionHeader>
        <FormSectionTitle>Rekapitulace pojištění</FormSectionTitle>

        <FormSectionDescription>
          <Image src={getLogo(Insurer.Kooperativa)} alt="Kooperativa" width="64px" maxH="48px" />
        </FormSectionDescription>
      </FormSectionHeader>

      <FormSectionBody>
        <Table variant="unstyled">
          <Tbody>
            <RecapTableRow col1="Typ pojištění" col2="Domácnost + stavba „Standard”" />
            <RecapTableRow col1="Odpovědnost" col2={formatPrice({ price: 2000000 })} />
            <RecapTableRow col1="Spoluúčast" col2="1 000 Kč, povodeň 1% min 5 000 Kč" />
            <RecapTableRow
              isHighlighted
              col1="Celkem"
              col2={<Text sx={{ fontWeight: 'semibold' }}>{formatPrice({ price: 4788 })}</Text>}
            />
          </Tbody>
        </Table>

        <Table variant="unstyled">
          <Tbody>
            <RecapTableRow col1="Splátky pojistného" col2="Roční" />
            <RecapTableRow
              col1="Datum sjednání"
              col2={formatDate({ date: new Date(2021, 10, 28) })}
            />
          </Tbody>
        </Table>

        <CancelContract insuranceId={0} callback={() => { }} />
      </FormSectionBody>
    </FormSection>
  )
}
